import {
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const TEXT_EXTENSIONS = ["doc", "docx", "txt", "md"];
const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "svg", "webp"];

const BROWSER_NON_RENDERABLE_IMAGE_CONTENT_TYPES = ["image/heic", "image/heif"];

export function isImageContentType(contentType: string | null | undefined): boolean {
  return contentType?.startsWith("image/") ?? false;
}

export function isBrowserRenderableImageContentType(
  contentType: string | null | undefined
): boolean {
  return (
    isImageContentType(contentType) &&
    !BROWSER_NON_RENDERABLE_IMAGE_CONTENT_TYPES.includes(contentType ?? "")
  );
}

export function isPdfContentType(contentType: string | null | undefined): boolean {
  return contentType === "application/pdf";
}

export function getFileTypeIcon(file: {
  contentType?: string | null;
  name?: string | null;
}) {
  const { contentType, name } = file;
  if (contentType) {
    if (isImageContentType(contentType)) return <FileImageOutlined />;
    if (isPdfContentType(contentType)) return <FilePdfOutlined />;
  }
  const ext = name?.split(".").pop()?.toLowerCase() ?? "";
  if (IMAGE_EXTENSIONS.includes(ext)) return <FileImageOutlined />;
  if (ext === "pdf") return <FilePdfOutlined />;
  if (TEXT_EXTENSIONS.includes(ext)) return <FileTextOutlined />;
  return <FileOutlined />;
}
